import { FC } from 'react'
import cx from 'classnames'

import { AvatarProps } from '../Avatar'
import Link, { LinkProps } from '../Link'
import { ActionButtonVariant } from '../ActionButton/styled'

import * as SC from './styled'

export type AdsEmitterBannerProps = {
  className?: string
  avatar: AvatarProps
  name: string
  role?: string
  smallDescription?: string
  button?: LinkProps
}

const AdsEmitterBanner: FC<AdsEmitterBannerProps> = ({
  className,
  avatar,
  name,
  role,
  smallDescription,
  button,
}) => {
  return (
    <SC.Container className={cx('AdsEmitterBanner', className)}>
      <SC.InfoWrapper>
        <SC.AvatarStyled {...avatar} />
        <SC.InfoBlock>
          <SC.Name>{name}</SC.Name>
          {role && <SC.Role>{role}</SC.Role>}
          <SC.DashedBorder />
          <SC.Description>{smallDescription}</SC.Description>
          {button && (
            <Link {...button}>
              <SC.Button
                variant={ActionButtonVariant.quaternary}
                text={button.text}
              />
            </Link>
          )}
        </SC.InfoBlock>
      </SC.InfoWrapper>
    </SC.Container>
  )
}

export default AdsEmitterBanner
